import { useTranslation } from "react-i18next";
import type { FieldError, UseFormMethods } from "react-hook-form";
import { useStyle } from "./style";
import { Loader } from "@common/Loader/Loader";
import { Grid, Typography } from "@mui/material";
import { LabeledTextField } from "@common/LabeledTextField/LabeledTextField";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";

interface IParams {
    errorMessage: string;
    isLoading: boolean;
    register: UseFormMethods["register"];
    error: FieldError | undefined;
    namePrefix?: string;
    onClearError?(): void;
    retryCode(): void;
    validateCode(): void;
}

export const ValidationCodeView = (props: IParams) => {
    const { register, validateCode, retryCode, error, isLoading, errorMessage, namePrefix, onClearError } = props;
    const { t } = useTranslation(["portin", "common", "validation"]);
    const { classes } = useStyle();
    const fieldName = namePrefix ? `${namePrefix}validationCode` : "validationCode";

    return (
        <Grid container>
            <Grid item xs={12}>
                <LabeledTextField
                    error={Boolean(error?.message) || Boolean(errorMessage)}
                    fullWidth
                    helperText={error?.message ?? errorMessage}
                    id="validationCode"
                    inputRef={register({
                        required: t("validation:required"),
                        validate: (value: string) =>
                            value && value.length === 6 ? undefined : t("validation:exactLengthError", { count: 6 }),
                    })}
                    isRequired
                    labelText={t("portin:validationCode")}
                    margin="dense"
                    name={fieldName}
                    onChange={() => {
                        if (onClearError) {
                            onClearError();
                        }
                    }}
                />
            </Grid>
            <Grid className={classes.validationActions} container spacing={2}>
                <Grid item xs={12}>
                    <Typography color="secondary" variant="small">
                        {t("portin:checkValidationCode")}
                    </Typography>
                </Grid>
                {isLoading && <Loader size={40} />}
                {!isLoading && (
                    <>
                        <Grid item>
                            <LabeledButton
                                className={classes.validationRetry}
                                color="primary"
                                labelText={t("common:retry")}
                                variant="text"
                                onClick={retryCode}
                            >
                                {t("portin:resendCode")}
                            </LabeledButton>
                        </Grid>
                        <Grid item>
                            <LabeledButton
                                className="xtest_confirm_validation_code"
                                color="primary"
                                labelText={t("common:confirm")}
                                onClick={validateCode}
                            >
                                {t("common:confirm")}
                            </LabeledButton>
                        </Grid>
                    </>
                )}
            </Grid>
        </Grid>
    );
};
